/* eslint-disable react/prop-types */
import { Mail, PhoneCall } from "lucide-react";

const ResearchCTA = ({ title, mail, description, number }) => {
  return (
    <>
      <section>
        <div className="container mx-auto">
          <div className="relative z-10 overflow-hidden rounded-2xl bg-[#910C28] py-12 px-8 md:p-[70px]">
            <div className="flex flex-wrap items-center -mx-4">
              <div className="w-full px-4 space-y-3 text-center ">
                <h2 className="mb-6 text-3xl font-bold leading-tight text-white sm:mb-8 sm:text-[40px]/[48px] lg:mb-0">
                  <span className="mb-4 text-4xl font-bold text-center font-domine">
                    {title}
                  </span>
                </h2>
                <span className="block max-w-4xl mx-auto mb-4 text-base font-medium text-white">
                  {description}
                </span>
              </div>
            </div>

            <div>
              <span className="absolute top-0 left-0 z-[-1]">
                <svg
                  width="189"
                  height="162"
                  viewBox="0 0 189 162"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <ellipse
                    cx="16"
                    cy="-16.5"
                    rx="173"
                    ry="178.5"
                    transform="rotate(180 16 -16.5)"
                    fill="url(#paint0_linear)"
                  />
                  <defs>
                    <linearGradient
                      id="paint0_linear"
                      x1="-157"
                      y1="-107.754"
                      x2="98.5011"
                      y2="-106.425"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="white" stopOpacity="0.07" />
                      <stop offset="1" stopColor="white" stopOpacity="0" />
                    </linearGradient>
                  </defs>
                </svg>
              </span>
              <span className="absolute bottom-0 right-0 z-[-1]">
                <svg
                  width="191"
                  height="208"
                  viewBox="0 0 191 208"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <ellipse
                    cx="173"
                    cy="178.5"
                    rx="173"
                    ry="178.5"
                    fill="url(#paint0_linear)"
                  />
                  <defs>
                    <linearGradient
                      id="paint0_linear"
                      x1="-3.27832e-05"
                      y1="87.2457"
                      x2="255.501"
                      y2="88.5747"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="white" stopOpacity="0.07" />
                      <stop offset="1" stopColor="white" stopOpacity="0" />
                    </linearGradient>
                  </defs>
                </svg>
              </span>
            </div>
            <div className="grid max-w-3xl grid-cols-1 gap-5 pt-5 mx-auto md:grid-cols-2 lg:pt-10 md:gap-10">
              <div className="flex flex-col items-center gap-3 py-5 bg-white rounded-2xl">
                <Mail className="size-8 " />
                <span className="text-base font-medium md:text-lg lg:text-xl">
                  {" "}
                  {mail}
                </span>
              </div>
              <div className="flex flex-col items-center gap-3 py-5 bg-white rounded-2xl">
                <PhoneCall className=" size-8" />
                <span className="text-base font-medium md:text-lg lg:text-xl">
                  {number}
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ResearchCTA;
